import { enableProdMode } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { Acl } from '@df/core/service/acl';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';

if (Acl.isProdMode()) {
    enableProdMode();
}


bootstrapApplication(AppComponent, appConfig).catch(err => console.error(err));

